// extracted by mini-css-extract-plugin
export default {"summary":"summaryDSNTY"};